import { Component, Input } from "@angular/core";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { ClipboardService } from "../../clipboard/clipboard.service";

@Component({
  selector: "ab-copy-button-with-tooltip",
  templateUrl: "./copy-button-with-tooltip.component.html",
})
export class CopyButtonWithTooltipComponent {
  @Input() public language: string;
  @Input() public textToCopy: string;

  constructor(private clipboard: ClipboardService) {}

  public copyText(tooltip: NgbTooltip) {
    this.clipboard.copy(this.textToCopy.trim());
    tooltip.open();
    setTimeout(() => {
      tooltip.close();
    }, 1500);
  }
}
